const SimulationEffectDateExtraForm = () => null;

export default SimulationEffectDateExtraForm;
